import { render, staticRenderFns } from "./CampaignView.vue?vue&type=template&id=67a1b40c&scoped=true"
import script from "./CampaignView.vue?vue&type=script&lang=ts"
export * from "./CampaignView.vue?vue&type=script&lang=ts"
import style0 from "./CampaignView.vue?vue&type=style&index=0&id=67a1b40c&prod&lang=sass&scoped=true"
import style1 from "./CampaignView.vue?vue&type=style&index=1&id=67a1b40c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1b40c",
  null
  
)

export default component.exports